<template>
  <div class="app-container">
    <h1>{{ $t('message.tasas.menu.pagar.titulo') }}</h1>
    <v-form ref="formFiltro" lazy-validation>
      <v-container fluid class="search">
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              v-model="filtroTabla"
              :placeholder="$t('message.comun.textoBusqueda')"
              append-outer-icon="search"
              solo
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-alert :value="true" color="info" icon="info" outline>
      {{ $t('message.comun.infoFechaActualizacionWeco', { fecha: ultimaActualizacion }) }}
    </v-alert>
    <v-data-table
      id="resultadosTabla"
      :headers="
        this.empresaSelected && this.empresaSelected.cdtipemp === 'P'
          ? [
              {
                value: 'fefinfacPublic',
                text: this.$t('message.comun.mesPerido'),
                align: 'center',
                sortable: false
              },
              {
                value: 'fepresenPublic',
                text: this.$t('message.comun.fechaNotificacion'),
                align: 'center',
                sortable: false
              },
              {
                value: 'nujustas',
                text: this.$t('message.comun.justificante.numero'),
                align: 'center',
                sortable: true
              },
              {
                value: 'imp',
                text: this.$t('message.comun.importeTotal'),
                align: 'center',
                sortable: false
              },
              {
                value: 'actions',
                text: this.$t('message.tasas.periodo.actions'),
                align: 'center',
                sortable: false
              }
            ]
          : [
              {
                value: 'feperdecPublic',
                text: this.$t('message.comun.mesDeclaracion'),
                align: 'center',
                sortable: false
              },
              {
                value: 'fefinfacPublic',
                text: this.$t('message.comun.mesFacturacion'),
                align: 'center',
                sortable: false
              },
              {
                value: 'fepresenPublic',
                text: this.$t('message.comun.fechaPresentacion'),
                align: 'center',
                sortable: false
              },
              {
                value: 'cdregist',
                text: this.$t('message.comun.justificante.codigoRegistro'),
                align: 'center',
                sortable: true
              },
              {
                value: 'nujustas',
                text: this.$t('message.comun.justificante.numero'),
                align: 'center',
                sortable: true
              },
              {
                value: 'imp',
                text: this.$t('message.comun.importeTotal'),
                align: 'center',
                sortable: false
              },
              {
                value: 'actions',
                text: this.$t('message.tasas.periodo.actions'),
                align: 'center',
                sortable: false
              }
            ]
      "
      :items="declaraciones"
      :no-data-text="$t('message.comun.sinDeclaracion')"
      :no-results-text="$t('message.comun.sinResultadosBusqueda')"
      :search="filtroTabla"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" v-if="empresaSelected.cdtipemp !== 'P'">
          {{ props.item.feperdecPublic }}
        </td>
        <td class="text-xs-center">
          {{ props.item.fefinfacPublic }}
        </td>
        <td class="text-xs-center">{{ props.item.fepresenPublic }}</td>
        <td class="text-xs-center" v-if="empresaSelected.cdtipemp !== 'P'">
          {{ props.item.cdregist }}
        </td>
        <td class="text-xs-center">{{ props.item.nujustas }}</td>
        <td class="text-xs-center">
          <Numeric
            :id="'importe' + props.item.id"
            :value="props.item.nueurtot"
            currency="€"
            readonly
          ></Numeric>
        </td>
        <td class="text-xs-center">
          <Icono
            :id="'pago' + props.item.id"
            :payload="props.item"
            color="success"
            class="mr-2"
            :tooltip="$t('message.tasas.menu.pagar.titulo')"
            @click="presetDeclarateHandler"
            >play_circle_filled
          </Icono>
        </td>
      </template></v-data-table
    >
  </div>
</template>

<script>
import { TIPO_DECLARACION_TASA, TASA_PENDIENTE_PAGO } from './constTasas';
import { Icono } from '@/components';
import { getDeclaraciones, getUltimaActulizacion } from '@/api/declaraciones';
import { mapActions, mapGetters } from 'vuex';
import { notificarError } from '@/utils/notification';
import moment from 'moment';
import { Numeric } from '@/components';

export default {
  name: 'pagotasas',
  data() {
    return {
      filtros: {
        idempres: null,
        cdtipdec: TIPO_DECLARACION_TASA,
        cdtipemp: null,
        paginaActual: 1,
        registrosPagina: 1000,
        pendientePago: TASA_PENDIENTE_PAGO
      },
      ultimaActualizacion: '',
      filtroTabla: '',
      pagination: { sortBy: null, descending: true },
      declaraciones: []
    };
  },
  components: {
    Icono,
    Numeric
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Tasas', to: '/tasas', disabled: false },
        { text: 'Pagar Tasa', to: '/tasas/pago', disabled: true }
      ],
      menuSelected: '/tasas/pago-tasa'
    });
    this.consultar();
    this.getActualizacionFecha();
  },
  computed: {
    ...mapGetters(['empresaSelected', 'userNIFCIF', 'userName'])
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    allowedMonths(val) {
      return (
        moment(val).toDate() <=
        moment()
          .startOf()
          .date(0)
          .toDate()
      );
    },
    getActualizacionFecha() {
      this.setLoading(true);
      getUltimaActulizacion()
        .catch(error => {
          notificarError(this, error);
        })
        .then(respuesta => {
          this.ultimaActualizacion = moment(respuesta.data).format('DD-MM-YYYY hh:mm:ss');
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    consultar() {
      this.filtros.idempres = this.empresaSelected.idempres;
      this.filtros.cdtipemp = this.empresaSelected.cdtipemp;
      let self = this;
      this.setLoading(true);
      // Preparamos el payload
      getDeclaraciones(this.filtros)
        .then(response => {
          self.declaraciones = response.data;
        })
        .catch(error => {
          notificarError(this, error);
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    presetDeclarateHandler(payload) {
      this.$router.push({
        name: 'pagotasa',
        params: { modelo: payload }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';
.search {
  background-color: $color-secondary;
  margin-bottom: 20px !important;
  padding: 15px 15px 0px 15px !important;
  .v-input__slot {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    margin: 0px !important;
    border: 0.5px solid;
    border-color: #999999;
    box-shadow: none;
  }
  .v-input__append-outer {
    background-color: #eca407 !important;
    min-width: 60px !important;
    margin: 0px !important;
    padding: 12px !important;
    i {
      font-weight: bold important;
    }
  }
}
</style>
